import { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AccountDropdown } from '@hungryroot/app-mhr';

import { useNextOrder } from '@hungryroot/orders';
import { queryClientOptions } from '@hungryroot/rest';
import { renderApp } from './utils/utils';

function getLocalStorageProp(trackingProp: string) {
  return window.localStorage.getItem(trackingProp) !== null;
}

function Init() {
  const [hasTrackingProp, setHasTrackingProp] = useState(false);
  const { order } = useNextOrder();

  const customerCredit = window.customer_credit;

  const accountBalance = customerCredit;
  const trackingProp = 'hr_dropdown_tooltip_shown';
  const showTooltip = order
    ? order.show_badge && !hasTrackingProp && accountBalance > 0
    : false;

  useEffect(() => {
    setHasTrackingProp(getLocalStorageProp(trackingProp));
  }, []);

  return (
    <AccountDropdown
      testid="header-account-dropdown"
      accountBalance={customerCredit}
      showTooltip={showTooltip}
      tooltipTrackingProp={trackingProp}
    />
  );
}

function renderAccountDropdown() {
  const queryClientInstance = new QueryClient(queryClientOptions);

  renderApp(
    <QueryClientProvider client={queryClientInstance}>
      <Init />
    </QueryClientProvider>,
    'account-dropdown-component'
  );
}

if (document.getElementById('account-dropdown-root') !== null) {
  renderAccountDropdown();
}
